import { MAP_TYPES } from '@deck.gl/carto';
 
const HISTORICALPOIVIEW_SOURCE_ID = 'historicalPointofInterestSource';
 
const source = {
  id: HISTORICALPOIVIEW_SOURCE_ID,
  type: MAP_TYPES.QUERY,
  connection: 'cartointegration',
  data: 'historical_point_of_interest_source',
};
 
export default source;